import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import React from 'react';
import {twMerge} from 'tailwind-merge';

type MaskVisibilityToggleProps = {
  title: string;
  className?: string;
  disabled: boolean;
  onToggleVisibility: () => void;
  children?: React.ReactNode;
};

export const MaskVisibilityToggle = ({
  title,
  className,
  disabled,
  onToggleVisibility,
  children,
}: MaskVisibilityToggleProps) => {
  return (
    <span
      className={twMerge(
        'visibility-indicator',
        disabled ? 'visible-unchecked' : 'visible-checked',
        'inline-flex flex-1 flex-row items-center gap-8 px-4 align-middle',
        className
      )}>
      <div
        className={twMerge(
          'visibility-indicator',
          `visible-${disabled ? 'unchecked' : 'checked'}`,
          'text-[#2e78c7]'
        )}>
        <LegacyWBIcon
          ariaLabel={`Toggle visibility of ${title}`}
          size="large"
          name={disabled ? 'hide' : 'show'}
          className={twMerge('icon cursor-pointer')}
          onClick={onToggleVisibility}
        />
      </div>
      {children}
    </span>
  );
};
